import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ViewerJsonComponent } from '@vectronic/ui';
import { DialogService } from '@vectronic/util';

@Component({
  selector: 'table-datatable-json',
  templateUrl: './datatable-json.component.html',
  styleUrls: ['./datatable-json.component.scss'],
  imports: [MatButtonModule],
})
export class DatatableJsonComponent {
  json = input<string>();

  private dialogService = inject(DialogService);

  onClickJson() {
    this.dialogService.open(ViewerJsonComponent, { data: { json: this.json() } });
  }
}
